import {useState} from 'react'
import {useProject} from '@/biz/project'
import {updateLastPromptTemplate} from '@/biz/promptTemplate.jsx'
import {useAi as _useAi} from './core'

const _useProject = prjId => {
    const {data} = useProject(prjId)

    if (prjId) {
        return data
    }
    else {
        return {
            prjId: '',
            prjName: '',
            prjNo: '',
        }
    }
}

export default ({biz, prjId, scene, sVer, ...options}) => {
    const _ai = _useAi(options)
    const project = _useProject(prjId)
    const [bizData, setBizData] = useState(biz)
    const [template, setTemplate] = useState()

    return {
        ..._ai,
        bizData,
        project: {...project, sVer},
        scene,
        setBizData,
        template,

        getIsReady() {
            return (
                _ai.getIsReady() &&
                Boolean(bizData && project && template) &&

                (
                    0 < this.draft.files.length ||
                    '1' !== this.template?.userMessageIsRequired
                )
            )
        },

        setTemplate(template) {
            if (! template) {
                return
            }

            if (this.template) {
                this.setMessages([])
            }

            setTemplate(template)

            if (template.openingRemarks) {
                this.addMessage({
                    content: template.openingRemarks,
                    echo: false,
                    role: 'assistant',
                    status: 'done',
                })
            }

            if (0 === template.llmPromptTemplateItems.length) {
                return
            }

            const {userMessageTemplate} = template.llmPromptTemplateItems[0]

            if (userMessageTemplate) {
                this.setDraft({
                    content: userMessageTemplate,
                    files: [],
                })
            }

            updateLastPromptTemplate(template)
        },
    }
}
